/**
 * 응답페이지 선택 id
 */
export const CHANGE = 'analysis/rows/choice/CHANGE' // 값 변경시
export const INIT = 'analysis/rows/choice/INIT'     // 초기 쿠키에서 값 가져올때

type Type = {
    ids: (string | number)[]
}

// order: answer => 보기순, count => 응답순
// pointType: point => 가중치로 계산, count => 응답수로 계산 
const initState: Type = {
    ids: []
}
 
interface ActionProps {
    type: string;
    ids: Type['ids'];
}
 
export default (state = initState, action: ActionProps) => {
    switch(action.type) {
        case CHANGE:
            return {
                ids: action.ids
            }
        case INIT:
            return initState
        default:
            return state
    }
}